import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("codeActions");

export const codeActionsTransport = transport;
export const CODE_ACTIONS_BASE_URL = baseUrl;
